// extracted by mini-css-extract-plugin
export default {"textInput":"bDyLcbE6n8JWKFm8","label":"hKCBtofT6A0o46yV"};